import isNil from 'lodash/isNil'
import React, { useEffect } from 'react'
import { useContext as useContextParent } from '../Context'
import { SearchFieldsDropdown } from './SearchFieldsDropdown'
import { getWindow } from '@ztechapps/common.utils'
import { ShowIf } from '@ztechapps/webui.util'
import { useSearchInputContext } from './Context'

export const SearchInputLayout = () => {
  const { searchPlaceHolder, searchByField, onChangeSearchField, searchValue, loading } = useContextParent()
  const { handleChange, onKeyDown } = useSearchInputContext()
  const inputRef = React.useRef<HTMLInputElement>(null)

  const [onFocusOnce, setOnFocusOnce] = React.useState(false)
  useEffect(() => {
    if (loading && !onFocusOnce) return
    // Never pull focus out of another field the user is typing in, such as the header global search.
    const { activeElement, body } = getWindow().document
    if (activeElement && activeElement !== body && activeElement !== inputRef.current) return
    inputRef.current?.focus()
    // onFocusOnce intentionally excluded: it also flips on the input's own onBlur (see below).
    // Depending on it here would re-fire this effect on every blur while not loading and immediately
    // call .focus() again, trapping focus in the input and making it impossible for the user to tab
    // or click away. Only a `loading` transition should decide whether to (re)focus.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const onFocus = () => {
    setOnFocusOnce(true)
  }
  const onBlur = () => {
    setOnFocusOnce(false)
  }

  return (
    <>
      <input
        type="search"
        placeholder={searchPlaceHolder}
        value={searchValue ?? ''}
        className="form-control my-search"
        onChange={handleChange}
        onKeyDown={onKeyDown}
        disabled={loading}
        onFocus={onFocus}
        onBlur={onBlur}
        ref={inputRef}
      />

      <ShowIf condition={searchByField && !isNil(onChangeSearchField)}>
        <SearchFieldsDropdown />
      </ShowIf>
    </>
  )
}
